import { ProductSize } from "./shopService.ts";

/**
 * Розмірна сітка з поля bodySize.
 *
 * У базі виміри зберігаються по-різному: інколи вже з підписами
 * ("груди: 88-92; стегна: 92-96;"), інколи просто числами ("84-88; 88-92;").
 * Підписи добираємо за кількістю вимірів, а не за типом одягу: жіночі штани
 * зберігаються з трьома вимірами так само, як сукні.
 *
 * Незрозумілий розмір — найбільша скарга покупців у дослідженні аудиторії,
 * тому таблиця має бути в картці, а не десь у загальній довідці.
 */
export interface SizeRow {
  name: string;
  measures: string;
}

const labelsFor = (productName: string, count: number): string[] => {
  if (count === 3) return ["груди", "талія", "стегна"];
  if (/штани|шорти/i.test(productName)) return ["талія", "стегна"];
  return ["груди", "стегна"];
};

export const buildSizeChart = (
  productName: string,
  sizes: ProductSize[]
): SizeRow[] =>
  (sizes || [])
    .filter((s) => s.total > 0 && s.bodySize)
    .map((s) => {
      const raw = s.bodySize.trim().replace(/;\s*$/, "").trim();

      if (raw.includes(":")) {
        return {
          name: s.name,
          measures: raw
            .split(";")
            .map((p) => p.trim())
            .filter(Boolean)
            .join(", "),
        };
      }

      const parts = raw
        .split(";")
        .map((p) => p.trim())
        .filter(Boolean);
      const labels = labelsFor(productName, parts.length);

      return {
        name: s.name,
        measures: parts
          .map((p, i) => (labels[i] ? `${labels[i]} ${p}` : p))
          .join(", "),
      };
    });
